import { useQuery } from '@tanstack/react-query'
import { fetchWorlds } from '@/services/worlds'

export function useWorlds() {
  const worldsQuery = useQuery({
    queryKey: ['worlds'],
    queryFn: fetchWorlds,
  })

  return {
    worlds: worldsQuery.data,
    isLoading: worldsQuery.isLoading,
    error: worldsQuery.error,
  }
}
